<template>
  <div class="porfolioScetions">
    <div class="details" v-for="detail in details" :key="detail.id">
      <img :src="detail.image" />
      <h2>{{ detail.heading }}</h2>
      <p>{{ detail.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      details: [
        {
          image: require("../assets/portifolio/Outgrowers.png"),
          heading: "26",
          description: "Milk Outgrowers",
        },
        {
          image: require("../assets/portifolio/Household.png"),
          heading: "5,000",
          description: "Registered Households",
        },
        {
          image: require("../assets/portifolio/Corporations.png"),
          heading: "100",
          description:
            "Corporations (restaurants, hotels, processors, and more)",
        },
        {
          image: require("../assets/portifolio/Litres_saved.png"),
          heading: "1,000,000",
          description: "litres saved from post-harvest loss",
        },
        {
            image: require("../assets/portifolio/Children.png"),
          heading: "20,000",
          description: "children on a daily milk plan",
        },
      ],
    };
  },
};
</script>

<style scoped>
h2 {
  color: #343540;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
}
p {
  max-width: 270px;
  color: #343540;
  font-family: "DM Sans";
  font-size: 20px;
  text-align: center;
}
img {
  max-width: 277.91px;
  margin: auto;
}
.porfolioScetions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.details {
  flex: 0 350px;
  max-width: 471.09px;
  margin: 20px;
  display: grid;
  place-items: center;
}
@media screen and (max-width:720px) {
    .details {
  margin-top: 30px;
}
}
</style>